import markLand from './markLand'
import camera from './camera'
export default {
  markLand,
  camera,
}
